// @flow

import { createReducer } from 'redux-act';

import {
  setPrefetchStatus,
  setAppWorking,
  unsetAppWorking,
  patchDomainContactsStart,
  patchDomainContactsEnd,
  setPayLaterProcess,
  setCorporatePackPrice,
  setPreferencesDialogOpen,
  postCartCheckoutStart,
  postCartCheckoutEnd,
} from './actions';

import type { State } from './types';

const initialState: State = {
  isCheckoutSequenceLoading: false,
  isComingFromPrefetch: false,
  isWorking: false,
  isPatchingDomainContacts: false,
  isPayLaterProcess: false,
  corporatePackMonthlyPrice: {
    currency: undefined,
    priceAfterTaxes: undefined,
    priceBeforeTaxes: undefined,
  },
  layout: {
    preferencesDialogOpen: false,
  },
  temporaryCart: {
    cartId: '',
    distinctProducts: 0,
  },
};

export default (createReducer(
  {
    [setPreferencesDialogOpen.getType()]: (
      state: State,
      open: boolean,
    ): State => {
      if (open === state.layout.preferencesDialogOpen) {
        return state;
      }
      return {
        ...state,
        layout: { ...state.layout, preferencesDialogOpen: open },
      };
    },
    [setPrefetchStatus.getType()]: (state: State, status: boolean): State => ({
      ...state,
      isComingFromPrefetch: status,
    }),

    [setAppWorking.getType()]: (state: State): State => ({
      ...state,
      isWorking: true,
    }),
    [unsetAppWorking.getType()]: (state: State): State => ({
      ...state,
      isWorking: false,
    }),

    [patchDomainContactsStart.getType()]: (state: State): State => ({
      ...state,
      isPatchingDomainContacts: true,
    }),

    [patchDomainContactsEnd.getType()]: (state: State): State => ({
      ...state,
      isPatchingDomainContacts: false,
    }),

    [setPayLaterProcess.getType()]: (state: State): State => ({
      ...state,
      isPayLaterProcess: true,
    }),

    [postCartCheckoutStart.getType()]: state => ({
      ...state,
      isCheckoutSequenceLoading: true,
    }),
    [postCartCheckoutEnd.getType()]: state => ({
      ...state,
      isCheckoutSequenceLoading: false,
    }),

    // $FlowFixMe[incompatible-type]
    [setCorporatePackPrice.getType()]: (
      state: State,
      price: State['corporatePackMonthlyPrice'],
    ): State => {
      if (price.currency === state.corporatePackMonthlyPrice.currency) {
        return state;
      }

      return {
        ...state,
        corporatePackMonthlyPrice: price,
      };
    },
  },
  initialState,
): {
  (): (state: State, payload?: mixed, meta?: mixed) => State,
  assignAll: ({ ... } | Array<mixed>, { ... } | Array<mixed>) => mixed,
  batch: ({ ... } | Array<mixed>) => mixed,
  bindAll: ({ ... } | Array<mixed>, { ... } | Array<mixed>) => mixed,
  disbatch: (mixed, void | Array<mixed>) => mixed,
  has: (actionCreator: mixed) => boolean,
  // $FlowFixMe[cannot-resolve-name]
  off: Reducer$Off,
  // $FlowFixMe[cannot-resolve-name]
  on: Reducer$On<State>,
  options: () => mixed,
  ...
});
